import { Chat } from '../../../chat/chat';

const LobbyChatLayout = () => <Chat />;

export default LobbyChatLayout;
